/* Stryde 2.0 theme JS */
(function () {
  'use strict';
  const S = window.Stryde || {};
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));

  /* ---------- money ---------- */
  function money(cents) {
    const fmt = S.moneyFormat || '{{amount_no_decimals}} kr';
    const n = cents / 100;
    const m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    const key = m ? m[1] : 'amount';
    const withSep = (v, dec, ds, ts) => {
      const parts = v.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return parts.join(ds);
    };
    let out;
    switch (key) {
      case 'amount_no_decimals': out = withSep(n, 0, ',', ' '); break;
      case 'amount_with_comma_separator': out = withSep(n, 2, ',', '.'); break;
      case 'amount_no_decimals_with_comma_separator': out = withSep(n, 0, ',', '.'); break;
      case 'amount_with_space_separator': out = withSep(n, 2, ',', ' '); break;
      case 'amount_no_decimals_with_space_separator': out = withSep(n, 0, ',', ' '); break;
      default: out = withSep(n, 2, '.', ',');
    }
    out = out.replace(/[.,]00$/, ''); /* strip trailing zeros: 299,00 -> 299 */
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, out);
  }
  window.StrydeMoney = money;

  /* ---------- toast ---------- */
  let toastEl;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t); toastEl._t = setTimeout(() => toastEl.classList.remove('is-visible'), 2600);
  }

  /* ---------- reveal ---------- */
  function initReveal() {
    const els = $$('.reveal:not(.in), .reveal-stagger:not(.in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || !S.animations) { els.forEach(e => e.classList.add('in')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(e => io.observe(e));
    const sweep = () => els.forEach(e => { if (e.classList.contains('in')) return; const r = e.getBoundingClientRect(); if (r.top < innerHeight * 0.98 && r.bottom > 0) e.classList.add('in'); });
    setTimeout(sweep, 400);
    let ticking = false;
    addEventListener('scroll', () => { if (ticking) return; ticking = true; requestAnimationFrame(() => { sweep(); ticking = false; }); }, { passive: true });
    setTimeout(() => els.forEach(e => e.classList.add('in')), 6000);
  }

  /* ---------- header ---------- */
  function initHeader() {
    const h = $('.header'); if (!h) return;
    const onScroll = () => h.classList.toggle('is-scrolled', scrollY > 8);
    onScroll(); addEventListener('scroll', onScroll, { passive: true });
    $$('.header__nav > li').forEach(li => {
      const btn = $('.header__link[aria-haspopup]', li); if (!btn) return;
      btn.addEventListener('click', e => { e.preventDefault(); const open = li.classList.toggle('is-open'); btn.setAttribute('aria-expanded', open); });
    });
    document.addEventListener('click', e => { if (!e.target.closest('.header__nav')) $$('.header__nav > li.is-open').forEach(li => li.classList.remove('is-open')); });
  }

  /* ---------- drawers ---------- */
  function openDrawer(d) { if (!d) return; d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; const f = $('button, a, input', $('.drawer__panel', d)); f && f.focus({ preventScroll: true }); }
  function closeDrawer(d) { if (!d) return; d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); if (!$('.drawer.is-open')) document.body.style.overflow = ''; }
  function initDrawers() {
    document.addEventListener('click', e => {
      const o = e.target.closest('[data-open-drawer]');
      if (o) { e.preventDefault(); openDrawer($(o.dataset.openDrawer)); return; }
      const c = e.target.closest('[data-close-drawer]');
      if (c) { e.preventDefault(); closeDrawer(c.closest('.drawer')); }
    });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') $$('.drawer.is-open').forEach(closeDrawer); });
    $$('.mmenu__link[aria-haspopup]').forEach(b => b.addEventListener('click', () => { const li = b.parentElement; const open = li.classList.toggle('is-open'); b.setAttribute('aria-expanded', open); }));
  }

  /* ---------- accordions / tabs ---------- */
  function initAccordions() {
    document.addEventListener('click', e => {
      const q = e.target.closest('.faq__q, .acc__q'); if (!q) return;
      const item = q.parentElement; const open = item.classList.toggle('is-open'); q.setAttribute('aria-expanded', open);
    });
    $$('[data-tabs]').forEach(root => {
      const tabs = $$('.tab', root), panels = $$('.tabpanel', root);
      tabs.forEach((t, i) => t.addEventListener('click', () => {
        tabs.forEach(x => { x.classList.remove('is-active'); x.setAttribute('aria-selected', 'false'); });
        panels.forEach(p => p.classList.remove('is-active'));
        t.classList.add('is-active'); t.setAttribute('aria-selected', 'true');
        if (panels[i]) { panels[i].classList.add('is-active'); $$('.reveal, .reveal-stagger', panels[i]).forEach(el => el.classList.add('in')); }
      }));
    });
  }

  /* ---------- announcement rotation ---------- */
  function initAnnouncement() {
    $$('.announcement__track').forEach(track => {
      const items = $$('.announcement__item', track); if (items.length < 2) return;
      let i = 0; setInterval(() => { items[i].classList.remove('is-active'); setTimeout(() => { i = (i + 1) % items.length; items[i].classList.add('is-active'); }, 520); }, 4500);
    });
  }

  /* ---------- cart ---------- */
  const cartDrawerSel = '#CartDrawer';
  async function refreshCart(sectionsHtml) {
    try {
      let html = sectionsHtml;
      if (!html) {
        const r = await fetch(`${S.routes.root}?sections=cart-drawer`, { headers: { Accept: 'application/json' } });
        const j = await r.json(); html = j['cart-drawer'];
      }
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = $('#CartDrawerContent', doc), cur = $('#CartDrawerContent');
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      const countEl = $('[data-cart-count]', doc);
      if (countEl) $$('[data-cart-count]').forEach(c => { c.textContent = countEl.textContent; c.classList.toggle('is-visible', parseInt(countEl.textContent, 10) > 0); });
    } catch (e) { console.warn(e); }
  }
  async function addToCart(items, btn, kod) {
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('disabled', ''); }
    try {
      /* niva 2: rabattkoden laggs till bland koderna som redan finns (2026-10-01) */
      if (kod) { try { const rot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; const c = await (await fetch(rot + 'cart.js')).json(); const k = (c.discount_codes || []).map(x => x.code); const nya = kod.split(',').map(s => s.trim()).filter(s => s && k.indexOf(s) < 0); if (nya.length) { nya.forEach(s => k.push(s)); await fetch(rot + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: k.join(',') }) }); } } catch (e) { } }
      const r = await fetch(S.routes.add + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items, sections: 'cart-drawer' }) });
      const j = await r.json();
      if (!r.ok) { toast(j.description || j.message || S.strings.error); return false; }
      await refreshCart(j.sections && j.sections['cart-drawer']);
      openDrawer($(cartDrawerSel));
      return true;
    } catch (e) { toast(S.strings.error); return false; }
    finally { if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('disabled'); } }
  }
  async function changeLine(line, quantity) {
    const drawer = $(cartDrawerSel); drawer && drawer.classList.add('is-busy');
    try {
      const r = await fetch(S.routes.change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity, sections: 'cart-drawer' }) });
      const j = await r.json();
      await refreshCart(j.sections && j.sections['cart-drawer']);
      if (document.body.classList.contains('template-cart')) location.reload();
    } catch (e) { toast(S.strings.error); }
    finally { drawer && drawer.classList.remove('is-busy'); }
  }
  window.StrydeCart = { add: addToCart, refresh: refreshCart, open: () => openDrawer($(cartDrawerSel)) };
  function initCart() {
    document.addEventListener('submit', e => {
      const f = e.target; if (!f.matches('form[data-ajax-cart]')) return;
      e.preventDefault();
      const fd = new FormData(f); const id = fd.get('id');
      const bundleChecked = f.closest('[data-product]') && $('input[data-bundle-qty]:checked', f.closest('[data-product]'));
      const qty = bundleChecked ? parseInt(bundleChecked.dataset.bundleQty, 10) : parseInt(fd.get('quantity') || '1', 10);
      if (!id) return;
      const props = {}; for (const [k, v] of fd.entries()) { const m = k.match(/^properties\[(.+)\]$/); if (m) props[m[1]] = v; }
      /* storleksval per enhet i bundle-nivan: gruppera per variant */
      const sizesWrap = bundleChecked && bundleChecked.closest('.bundle__tier') && $('[data-bundle-sizes]', bundleChecked.closest('.bundle__tier'));
      /* niva 2: gratisprodukt (e-bok) och rabattkod */
      const gift = bundleChecked ? parseInt(bundleChecked.dataset.bundleGift || '0', 10) : 0;
      const kod = bundleChecked ? (bundleChecked.dataset.bundleCode || '') : '';
      if (sizesWrap) {
        const map = {};
        $$('select[data-bundle-variant]', sizesWrap).forEach(s => { map[s.value] = (map[s.value] || 0) + 1; });
        const items = Object.keys(map).map(k => ({ id: parseInt(k, 10), quantity: map[k] }));
        if (gift) items.push({ id: gift, quantity: 1 });
        if (items.length) { addToCart(items, $('[type=submit]', f), kod); return; }
      }
      const item = { id: parseInt(id, 10), quantity: qty }; if (Object.keys(props).length) item.properties = props;
      const lista = [item]; if (gift) lista.push({ id: gift, quantity: 1 });
      addToCart(lista, $('[type=submit]', f), kod);
    });
    document.addEventListener('click', e => {
      const qa = e.target.closest('[data-quick-add]');
      if (qa) {
        e.preventDefault();
        const row = qa.closest('[data-upsell]'); const sel = row && $('[data-upsell-select]', row);
        const id = sel ? parseInt(sel.value, 10) : parseInt(qa.dataset.quickAdd, 10);
        addToCart([{ id, quantity: 1 }], qa); return;
      }
      const rm = e.target.closest('[data-line-remove]');
      if (rm) { e.preventDefault(); changeLine(parseInt(rm.dataset.lineRemove, 10), 0); return; }
      const pm = e.target.closest('[data-line-qty]');
      if (pm) { e.preventDefault(); const input = $('input', pm.parentElement); const line = parseInt(input.dataset.line, 10); const v = Math.max(0, parseInt(input.value, 10) + parseInt(pm.dataset.lineQty, 10)); changeLine(line, v); return; }
      const st = e.target.closest('.qty button');
      if (st) { const i = $('input', st.parentElement); i.value = Math.max(1, (parseInt(i.value, 10) || 1) + parseInt(st.dataset.step, 10)); }
    });
    document.addEventListener('change', e => {
      const i = e.target;
      if (i.matches('[data-upsell-select]')) {
        const opt = i.options[i.selectedIndex]; const row = i.closest('[data-upsell]'); const pr = row && $('[data-upsell-price]', row);
        if (pr && opt.dataset.price) pr.textContent = money(parseInt(opt.dataset.price, 10));
        return;
      }
      if (!i.matches('.cline__qty input')) return;
      changeLine(parseInt(i.dataset.line, 10), Math.max(0, parseInt(i.value, 10) || 0));
    });
  }

  /* ---------- product ---------- */
  function initProduct() {
    $$('[data-product]:not([data-init])').forEach(root => {
      root.setAttribute('data-init', '1');
      const dataEl = $('[data-product-json]', root); if (!dataEl) return;
      const product = JSON.parse(dataEl.textContent);
      const idInput = $('input[name=id]', root);
      const priceEl = $('[data-price]', root), compareEl = $('[data-compare]', root), saveEl = $('[data-save]', root);
      const btn = $('[data-add-btn]', root), btnLabel = btn && $('.btn__label', btn);
      const stickyPrice = $('[data-sticky-price]');
      const gallery = $('[data-gallery]', root);
      const bundle = $('[data-bundle]', root);

      function selectedOptions() {
        return product.options.map((o, i) => {
          const checked = $(`[data-option-index="${i}"] input:checked`, root);
          if (checked) return checked.value;
          const sel = $(`[data-option-index="${i}"] select`, root);
          return sel ? sel.value : null;
        });
      }
      const hasPicker = !!$('[data-option-index]', root);
      function findVariant(opts) {
        if (!hasPicker) return product.variants[0];
        return product.variants.find(v => v.options.every((o, i) => o === opts[i]));
      }
      function updateAvailability(opts) {
        product.options.forEach((o, i) => {
          $$(`[data-option-index="${i}"] .swatch`, root).forEach(sw => {
            const val = $('input', sw).value;
            const anyAvail = product.variants.some(v => v.available && v.options[i] === val && v.options.every((ov, k) => k === i || k > i || ov === opts[k]));
            sw.classList.toggle('is-unavailable', !anyAvail);
          });
        });
      }
      function render() {
        const opts = selectedOptions();
        const v = findVariant(opts);
        $$('.opt', root).forEach((opt, i) => { const val = $('[data-option-value]', opt); if (val) val.textContent = opts[i] || ''; });
        $$('.swatch', root).forEach(sw => sw.classList.toggle('is-active', $('input', sw).checked));
        updateAvailability(opts);
        if (!v) { if (btn) { btn.setAttribute('disabled', ''); btnLabel.textContent = S.strings.unavailable; } return; }
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price);
        if (compareEl) { if (v.compare_at_price > v.price) { compareEl.textContent = money(v.compare_at_price); compareEl.hidden = false; } else compareEl.hidden = true; }
        if (saveEl) { if (v.compare_at_price > v.price) { saveEl.textContent = saveEl.dataset.saveMode === 'pct' ? ((saveEl.dataset.savePrefix || '') + ' ' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%') : ((saveEl.dataset.savePrefix || 'Spara') + ' ' + money(v.compare_at_price - v.price)); saveEl.hidden = false; } else saveEl.hidden = true; }
        if (stickyPrice) stickyPrice.textContent = money(v.price);
        if (btn) { if (v.available) { btn.removeAttribute('disabled'); setBtnLabel(v.price, v.compare_at_price > v.price ? v.compare_at_price : 0); } else { btn.setAttribute('disabled', ''); btnLabel.textContent = S.strings.soldOut; } }
        if (bundle) {
          $$('.bundle__tier', bundle).forEach(t => {
            const inp = $('input', t); const qty = parseInt(inp.dataset.bundleQty, 10); const fixed = parseInt(inp.dataset.bundleFixed, 10) || 0; const pct = parseFloat(inp.dataset.bundlePct) || 0;
            const base = v.compare_at_price > v.price ? v.compare_at_price : v.price; const compare = base * qty; const total = fixed > 0 ? fixed : Math.round(v.price * qty * (100 - pct) / 100);
            inp.dataset.bundlePrice = total; inp.dataset.bundleCompare = compare;
            $('.bundle__now', t).textContent = money(total);
            const s = $('.bundle__price s', t); if (s) { s.hidden = !(total < compare); s.textContent = money(compare); }
            const u = $('.bundle__unit', t); if (u) u.textContent = money(Math.round(total / qty)) + (u.dataset.suffix || '');
            const sv = $('.bundle__save', t); if (sv) { sv.hidden = !(total < compare); sv.textContent = (sv.dataset.prefix || '') + ' ' + money(compare - total); }
          });
          applyBundle();
        }
        if (v.featured_media && gallery) showMedia(v.featured_media.id);
        try { const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url); } catch (e) {}
      }
      function setBtnLabel(price, compare) {
        if (!btn || !btnLabel) return;
        const label = btn.dataset.label || S.strings.add;
        if (!btn.dataset.showPrice) { btnLabel.textContent = label; return; }
        btnLabel.innerHTML = '';
        btnLabel.appendChild(document.createTextNode(label + ' '));
        const p = document.createElement('span'); p.className = 'btn__price'; p.textContent = '– ' + money(price);
        if (compare > price) { const s = document.createElement('s'); s.textContent = money(compare); p.appendChild(document.createTextNode(' ')); p.appendChild(s); }
        btnLabel.appendChild(p);
      }
      root.addEventListener('change', e => { if (e.target.closest('[data-option-index]')) render(); });

      /* bundle tiers -> quantity */
      function applyBundle() {
        const checked = $('input[data-bundle-qty]:checked', bundle); if (!checked) return;
        $$('.bundle__tier', bundle).forEach(t => t.classList.toggle('is-active', $('input', t) === checked));
        const qtyInput = $('input[name=quantity]', root); if (qtyInput) qtyInput.value = checked.dataset.bundleQty;
        if (stickyPrice) stickyPrice.textContent = money(parseInt(checked.dataset.bundlePrice, 10));
        if (btn && !btn.hasAttribute('disabled')) setBtnLabel(parseInt(checked.dataset.bundlePrice, 10), parseInt(checked.dataset.bundleCompare, 10) || 0);
      }
      if (bundle) { bundle.addEventListener('change', applyBundle); applyBundle(); }

      /* gallery */
      let slides = [], thumbs = [], dots = [], cur = 0;
      function showMedia(id) { const i = slides.findIndex(s => s.dataset.mediaId == id); if (i >= 0) go(i); }
      function go(i) {
        if (!slides.length) return;
        cur = (i + slides.length) % slides.length;
        slides.forEach((s, k) => s.classList.toggle('is-active', k === cur));
        thumbs.forEach((t, k) => t.classList.toggle('is-active', k === cur));
        dots.forEach((d, k) => d.classList.toggle('is-active', k === cur));
        const t = thumbs[cur]; if (t && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
      if (gallery) {
        slides = $$('.gallery__main img', gallery); thumbs = $$('.gallery__thumb', gallery); dots = $$('.gallery__dots span', gallery);
        thumbs.forEach((t, i) => t.addEventListener('click', () => go(i)));
        const prev = $('.gallery__nav--prev', gallery), next = $('.gallery__nav--next', gallery);
        prev && prev.addEventListener('click', () => go(cur - 1));
        next && next.addEventListener('click', () => go(cur + 1));
        let x0 = null; const main = $('.gallery__main', gallery);
        main.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', e => { if (x0 == null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) go(dx < 0 ? cur + 1 : cur - 1); x0 = null; });
        const active = slides.findIndex(s => s.classList.contains('is-active')); if (active >= 0) cur = active;
      }
      render();

      /* sticky ATC */
      const sticky = $('.sticky-atc'); const buy = $('.buy', root);
      if (sticky && buy && 'IntersectionObserver' in window) {
        new IntersectionObserver(en => sticky.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0), { threshold: 0 }).observe(buy);
        const sb = $('[data-sticky-add]', sticky);
        sb && sb.addEventListener('click', () => { const f = $('form[data-ajax-cart]', root); f && f.requestSubmit(); });
      }
    });
  }

  /* ---------- init ---------- */
  function init() { initReveal(); initHeader(); initDrawers(); initAccordions(); initAnnouncement(); initCart(); initProduct(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', () => { initReveal(); initProduct(); });
})();

/* Varukorg v2 (2026-10-02): rabattkod i panelen, laggs till bland koderna som redan finns */
(function () {
  function rot() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  async function anvand(btn) {
    var wrap = btn.closest('.cd2-kod'); if (!wrap) return;
    var inp = wrap.querySelector('[data-cart-code-input]'); var kod = (inp && inp.value || '').trim();
    if (!kod) { inp && inp.focus(); return; }
    var fel = inp.dataset.msgInvalid || '';
    btn.disabled = true;
    try {
      var c = await (await fetch(rot() + 'cart.js')).json();
      var k = (c.discount_codes || []).map(function (x) { return x.code; });
      if (k.map(function (x) { return x.toUpperCase(); }).indexOf(kod.toUpperCase()) < 0) k.push(kod);
      var r = await fetch(rot() + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: k.join(','), sections: 'cart-drawer' }) });
      var j = await r.json();
      var hit = (j.discount_codes || []).filter(function (x) { return x.code.toUpperCase() === kod.toUpperCase(); })[0];
      if (!hit || !hit.applicable) {
        /* en kod som inte galler tas bort igen, sa att den inte foljer med till kassan */
        var kvar = k.filter(function (x) { return x.toUpperCase() !== kod.toUpperCase(); });
        r = await fetch(rot() + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: kvar.join(','), sections: 'cart-drawer' }) });
        j = await r.json();
      }
      if (window.StrydeCart && window.StrydeCart.refresh) await window.StrydeCart.refresh(j.sections && j.sections['cart-drawer']);
      if (!hit || !hit.applicable) {
        var d = document.querySelector('#CartDrawer .cd2-kod'); if (d) { d.open = true; var m = d.querySelector('[data-cart-code-msg]'); if (m) m.textContent = fel; var i2 = d.querySelector('[data-cart-code-input]'); if (i2) i2.value = kod; }
      }
    } catch (e) { } finally { btn.disabled = false; }
  }
  document.addEventListener('click', function (e) { var b = e.target.closest('[data-cart-code-apply]'); if (b) { e.preventDefault(); anvand(b); } });
  document.addEventListener('keydown', function (e) { if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-cart-code-input]')) { e.preventDefault(); var b = e.target.closest('.cd2-kod').querySelector('[data-cart-code-apply]'); if (b) anvand(b); } });
})();
